import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RichWarningMessageComponent } from './rich-warning-message.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [RichWarningMessageComponent],
  imports: [CommonModule, SharedModule],
  exports: [RichWarningMessageComponent]
})
export class RichWarningMessageModule {}
